export default {"src":"/_next/static/media/toggle.91473616.gif","height":590,"width":610,"blurWidth":0,"blurHeight":0};